import { defineStore } from 'pinia'
import type { GetContractInformationResponse } from '@/models/api/get-contract-information-response'
import { api } from '@/services'
import { isLoading } from '@/utils/functions/is-loading'
import { ContractStatus } from '~library/enums'
import { isApiSuccess } from '~library/utils/functions'

/** 合約資訊管理 */
export const useContractStore = defineStore('contract', () => {
  /** 合約資訊 */
  const contractInformation = ref<GetContractInformationResponse | null>(null)

  /** 合約是否已終止 */
  const isContractExpired = computed(() => {
    return contractInformation.value?.status === ContractStatus.TERMINATED
  })

  /** 取得合約資訊 */
  async function getContractInformation() {
    const responseData = await isLoading(api.myAccount.getContractInformation())

    if (isApiSuccess(responseData)) {
      contractInformation.value = responseData.data
    } else {
      contractInformation.value = null
    }
  }

  return {
    /** 合約是否已終止 */
    isContractExpired,
    /** 取得合約資訊 */
    getContractInformation
  }
})
